import { transformComplementary } from "@/datastore/dataProvider";
import { fetchProducts } from "@/utils";

export async function getProductHandlesFromSkuIds(skuIds: string[]) {
  const response = await fetch(
    `https://culture-circle.azurewebsites.net/graphql`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        variables: {
          skuIds,
        },
        query: `query GetProductHandlesFromSkuIds($skuIds: [String!]!) {
          productHandles: allProducts(filters: {title: {inList: $skuIds}}, first: ${skuIds.length}) {
            edges {
              node {
                slug
              }
            }
          }
        }`,
      }),
    },
  );

  const data = await response.json();

  return (data?.data?.productHandles?.edges ?? [])
    ?.map((edge: any) => edge?.node?.slug)
    .filter(Boolean);
}

export async function getLowTicketSizeRecommendationFromHandles(
  handles: string[],
): Promise<Record<string, Record<string, string[]>>> {
  const responses = await Promise.allSettled(
    handles.map((handle) => getLowTicketSizeRecommendations(handle)),
  );

  const finalResponses: Record<string, Record<string, string[]>>[] = responses
    .map((response) => {
      if (response.status === "fulfilled") {
        return response.value;
      }

      return null;
    })
    .filter(Boolean);

  const mergedResponses = finalResponses.reduce((acc, curr) => {
    const keys = Object.keys(curr);

    keys.forEach((key) => {
      if (!acc[key]) {
        acc[key] = curr[key];
      } else {
        Object.keys(curr[key]).forEach((subkey) => {
          acc[key][subkey] = [
            ...(acc[key][subkey] ?? []),
            ...curr[key][subkey],
          ];
        });
      }
    });

    return acc;
  }, {});

  return mergedResponses;
}

export async function getLowTicketSizeRecommendations(id: string) {
  const path = `/${window.helium.brandData.orgId}/products/${id}/complementary-low-ticket-size${
    window.helium.brandData.storeId ? `.${window.helium.brandData.storeId}` : ""
  }.json`;

  const baseUrl = "https://d21xluao80us9l.cloudfront.net";

  const response = await fetch(baseUrl + path);

  const data = await response.json();

  return transform(transformComplementary(data));
}

interface ResponseItem {
  subcategory: string;
  attribute: string;
  attributeValue: string;
  results: string[];
}

async function transform(complementaryIds: string[]) {
  console.log({ complementaryIds });
  return Object.fromEntries(
    await Promise.all(
      Object.entries(complementaryIds).map(
        async ([category, subcategories]) => {
          if (Array.isArray(complementaryIds[category])) {
            const products = await fetchProducts(
              complementaryIds[category].slice(0, 5),
            );
            if (products.length === 0) return [category, {}];
            return [
              category,
              {
                complementary: products,
              },
            ];
          }

          const resolvedSubcategories = Object.fromEntries(
            await Promise.all(
              Object.entries(subcategories).map(async ([subcategory, ids]) => {
                return [subcategory, await fetchProducts(ids)];
              }),
            ),
          );

          return [category, resolvedSubcategories];
        },
      ),
    ),
  );
}
